export default "__VITE_ASSET__D9JUKH5W__"